import {
  NgModule,
  ModuleWithProviders,
  ANALYZE_FOR_ENTRY_COMPONENTS,
  Inject,
  Optional,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpModule } from "@angular/http";

import {
  HttpClient,
  HTTP_INTERCEPTORS,
  HttpClientModule,
} from "@angular/common/http";
import { KreForm } from "./components/kre-form";
import { KreFormField } from "./components/kre-form.field";
import { KreFormAttributes } from "./components/kre-form.attributes";

import {
  KreFormConfig,
  ConfigOption,
  KreFORM_CONFIG,
  APPConfig,
} from "./services/kre-form.config";

import { KreFormOther, KreFormOtherConfig } from "./services/kre-form.other";
import { KreFormBuilder } from "./services/kre-form.builder";
import { KreFormGroup } from "./templates/kre-form.group";
import { KreFormValidationMessage } from "./templates/kre-form.validation-message";
import { KreFormTemplateType } from "./templates/field-template.type";

import { FieldExpressionExtension } from "./extensions/field-expression/field-expression";
import { FieldValidationExtension } from "./extensions/field-validation/field-validation";
import { FieldFormExtension } from "./extensions/field-form/field-form";
import { CoreExtension } from "./extensions/core/core";
import { KreFormCommonService } from "./tools/common";
import { SafeHtmlPipe } from "./tools/safehtml.pipe";
import { TagsPipe } from "./tools/tags.pipe";
import { FieldArrayType } from "./templates/field-array.type";
import { FormGlobalService } from "./tools/global.event";

const pipes = [SafeHtmlPipe, TagsPipe];

export function defaultKreFormConfig(
  kreFormConfig: KreFormConfig
): ConfigOption {
  return {
    types: [
      { name: "kre-form-group", component: KreFormGroup },
      { name: "template", component: KreFormTemplateType },
    ],
    extensions: [
      { name: "core", extension: new CoreExtension(kreFormConfig) },
      {
        name: "field-validation",
        extension: new FieldValidationExtension(kreFormConfig),
      },
      { name: "field-form", extension: new FieldFormExtension(kreFormConfig) },
      { name: "field-expression", extension: new FieldExpressionExtension() },
    ],
  };
}

@NgModule({
  declarations: [
    KreForm,
    KreFormField,
    KreFormAttributes,
    KreFormGroup,
    KreFormValidationMessage,
    KreFormTemplateType,
    FieldArrayType as any,
    ...pipes,
  ],
  entryComponents: [KreFormGroup, KreFormTemplateType],
  exports: [
    KreForm,
    KreFormField,
    KreFormAttributes,
    KreFormGroup,
    KreFormValidationMessage,
    ...pipes,
  ],
  imports: [HttpModule, HttpClientModule, CommonModule],
  providers: [KreFormCommonService, FormGlobalService],
})
export class KreFormModule {
  static forRoot(
    config: ConfigOption = {}
  ): ModuleWithProviders<KreFormModule> {
    return {
      ngModule: KreFormModule,
      providers: [
        {
          provide: KreFORM_CONFIG,
          multi: true,
          useFactory: defaultKreFormConfig,
          deps: [KreFormConfig],
        },
        { provide: KreFORM_CONFIG, useValue: config, multi: true },
        {
          provide: ANALYZE_FOR_ENTRY_COMPONENTS,
          useValue: config,
          multi: true,
        },
        KreFormConfig,
        KreFormBuilder,
      ],
    };
  }

  static forChild(
    config: ConfigOption = {}
  ): ModuleWithProviders<KreFormModule> {
    return {
      ngModule: KreFormModule,
      providers: [
        { provide: KreFORM_CONFIG, useValue: config, multi: true },
        {
          provide: ANALYZE_FOR_ENTRY_COMPONENTS,
          useValue: config,
          multi: true,
        },
        KreFormBuilder,
      ],
    };
  }

  static forConfig(config: string): ModuleWithProviders<KreFormModule> {
    return {
      ngModule: KreFormModule,
      providers: [
        { provide: KreFormOtherConfig, useValue: config, multi: true },
        {
          provide: ANALYZE_FOR_ENTRY_COMPONENTS,
          useValue: config,
          multi: true,
        },
        KreFormOther,
      ],
    };
  }

  constructor(
    configService: KreFormConfig,
    @Optional() @Inject(KreFORM_CONFIG) configs: ConfigOption[] = [],

    otherService: KreFormOther,
    @Optional() @Inject(KreFormOtherConfig) configOther: any[] = []
  ) {
    if (!configs) {
      return;
    }

    configs.forEach((config) => configService.addConfig(config));

    if (configOther && configOther.length > 0) {
      otherService.setFormOtherConfig(configOther[0]);
    }
  }
}
